import React from 'react'
import {Navigation} from '../components/Navigation'
import {Placeholder, Label, Table, Button, Icon, Card, Transition, Loader} from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import { useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import {Route} from '../components/Router.js'
import { default as Users } from '../components/users/users';

export default function Bookmaker() {
  return (
    
        <Route path="/system/users*" exact={true} component={Users} />
    
  )
}